import React, { useEffect, useState } from "react";
import { ClipboardX, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/Cards";

export default function MissingEntriesBanner({ goTo }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reminders/missing-entries").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.count === 0) return null;
  return (
    <Card className="p-4 border-amber-400/40 bg-amber-400/5" data-testid="missing-entries-banner">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-amber-400/15 text-amber-400 flex items-center justify-center shrink-0"><ClipboardX className="h-5 w-5" /></div>
          <div>
            <div className="font-heading font-semibold text-amber-400">Bugün {data.count} müşterinin kişi girişi yapılmamış</div>
            <div className="text-sm text-muted-foreground mt-0.5 flex flex-wrap gap-1.5">
              {data.missing.slice(0, 8).map((m) => <span key={m.customer_id} data-testid={`missing-entry-${m.customer_id}`} className="rounded-md bg-card/70 border border-border px-2 py-0.5 text-xs">{m.name}</span>)}
              {data.count > 8 && <span className="text-xs">+{data.count - 8}</span>}
            </div>
          </div>
        </div>
        <button onClick={() => goTo && goTo("daily-entry")} data-testid="missing-entries-goto" className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline">Günlük girişe git <ChevronRight className="h-4 w-4" /></button>
      </div>
    </Card>
  );
}
